import { Component, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  tablerArrowLeft,
  tablerArrowUpRight,
  tablerBell,
  tablerChevronDown,
  tablerDots,
  tablerMenu2,
  tablerPlus,
  tablerSearch,
  tablerUserCircle,
  tablerX,
} from '@ng-icons/tabler-icons';

@Component({
  selector: 'oc-action-item',
  standalone: true,
  imports: [CommonModule, NgIconComponent],
  providers: [
    provideIcons({
      tablerSearch,
      tablerBell,
      tablerUserCircle,
      tablerMenu2,
      tablerArrowLeft,
      tablerX,
      tablerPlus,
      tablerDots,
      tablerArrowUpRight,
      tablerChevronDown,
    }),
  ],
  template: `<div
    class="action-item"
    [class.action-item-sm]="size === 'sm'"
    [class.action-item-md]="size === 'md'"
    [class.action-item-lg]="size === 'lg'"
    [class.action-item-invert]="invert"
  >
    <ng-icon [name]="icon" [size]="iconSize" [color]="iconColor"></ng-icon>
  </div>`,
  styles: `
    .action-item {      
      width: 3.0rem;
      height: 3.0rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 999rem;

      &:hover {
        background: #f2f2f2;
      }
    }

    .action-item-lg {
      width: 3.5rem;
      height: 3.5rem;
    }

    .action-item-sm {
      width: 2.5rem;
      height: 2.5rem;
    }

    .action-item-invert {
      &:hover {
        background: rgba(255,255,255,0.1);
      }
    }
  `,
})
export class ActionItemComponent {
  @Input() icon = '';
  @Input() size = 'md';
  @Input() invert = false;
  @Input() stopPropagation = false;

  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    if (this.stopPropagation) {
      event.stopPropagation();
    }
  }

  get iconSize(): string {
    switch (this.size) {
      case 'lg':
        return '1.75rem';
      case 'sm':
        return '1.35rem';
      default:
        return '1.55rem';
    }
  }

  get iconColor(): string {
    return this.invert ? '#fff' : '#333';
  }
}
